import unauthenticated from './http-clients/unauthenticated'
import authenticated from './http-clients/authenticated'
import config from '../config'

const _url = '/token'

export default {
  login (data) {
    Object.assign(data, {
      client_id: config.clientID,
      client_secret: config.clientSecret,
      grant_type: 'password'
    })

    return unauthenticated({
      url: _url,
      method: 'post',
      data
    })
  },

  refresh (data) {
    Object.assign(data, {
      client_id: config.clientID,
      client_secret: config.clientSecret,
      grant_type: 'refresh_token'
    })

    return unauthenticated({
      url: _url,
      method: 'post',
      data
    })
  },

  logout () {
    return authenticated({
      url: _url,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/token.js